import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBPS040CountRequest } from 'types/MCBPS040/MCBPS040CountRequest'
import { MCBPS040InitializeDisplayInfoDto } from 'types/MCBPS040/MCBPS040InitializeDisplayInfoDto'
import { MCBPS040SearchRequest } from 'types/MCBPS040/MCBPS040SearchRequest'
import { MCBPS040UploadHistoryInfoResultDto } from 'types/MCBPS040/MCBPS040UploadHistoryInfoResultDto'

interface SelectionFileUploadHistoryData {
  initDisplayInfo: MCBPS040InitializeDisplayInfoDto
  uploadHistoryInfoResult: MCBPS040UploadHistoryInfoResultDto
}

const initialState: SelectionFileUploadHistoryData = {
  initDisplayInfo: {
    selectionFileNameInfoList: [],
    uploadHistoryInfoList: [],
  },
  uploadHistoryInfoResult: {
    uploadHistoryInfo: [],
  },
}
const selectionFileUploadHistoryReducer = createSlice({
  name: 'selectionFileUploadHistory',
  initialState,
  reducers: {
    historyInit(state) {
      return state
    },
    setInitDisplayInfo(state, action: PayloadAction<MCBPS040InitializeDisplayInfoDto>) {
      state.initDisplayInfo = action.payload
      state.uploadHistoryInfoResult.uploadHistoryInfo = action.payload.uploadHistoryInfoList
      state.initDisplayInfo.uploadHistoryInfoList = []
    },
    historyFind(state, action: PayloadAction<MCBPS040SearchRequest>) {
      return state
    },
    setUploadHistoryInfoResult(state, action: PayloadAction<MCBPS040UploadHistoryInfoResultDto>) {
      state.uploadHistoryInfoResult = action.payload
    },
    selectUploadCount(state, action: PayloadAction<MCBPS040CountRequest>) {
      return state
    },
    setUploadHistoryInfo(state) {
      state.uploadHistoryInfoResult.uploadHistoryInfo = []
    },
  }
})

export const {
  historyInit,
  setInitDisplayInfo,
  historyFind,
  setUploadHistoryInfoResult,
  selectUploadCount,
  setUploadHistoryInfo,
} = selectionFileUploadHistoryReducer.actions

export default selectionFileUploadHistoryReducer.reducer